import { useTranslation } from 'react-i18next';

import { Drawer } from 'components/shared';

import CopyPeriodForm from './CopyPeriodForm';

type Props = {
  open: boolean;
  employeeEntityId?: string;
  handleClose: () => void;
};

export default function CopyWeekDrawer({
  open,
  employeeEntityId,
  handleClose
}: Props) {
  const { t } = useTranslation('common', { keyPrefix: 'activityPlanning' });

  return (
    (<Drawer
      title={t('copyPeriod')}
      anchor="right"
      open={open}
      onClose={handleClose}
    >
      {open && ( // Don't fetch data until drawer is open
        (<CopyPeriodForm
          employeeEntityId={employeeEntityId}
          handleClose={handleClose}
        />)
      )}
    </Drawer>)
  );
}
